import dayjs from '@/plugins/dayjs';

export default function formatDateTimeByLocale(timestamp: number): string {
  return timestamp ? dayjs(timestamp).format('YYYY.MM.DD hh:mm A') : '-';
}
